import {AppPermissions} from '@shared/constants/Mapping';
import useTicketingSystemPermission from '../../TicketingSystem/hooks/useTicketingSystemPermission';

type IReferralsTicketsPermission = typeof AppPermissions.REFERRALS_TICKETS;
interface IUseReferralsTicketsPermissionProps {
  objectFunction: Exclude<keyof IReferralsTicketsPermission, 'NAME'>;
}
const useReferralsTicketsPermissions = (
  props: IUseReferralsTicketsPermissionProps = {
    objectFunction: 'LIST'
  }
): boolean => {
  const {objectFunction} = props;
  return useTicketingSystemPermission({
    module: 'REFERRALS_TICKETS',
    objectFunction,
    groupPermission: 'REFERRALS_TICKETS_ENABLE'
  });
};

export default useReferralsTicketsPermissions;
